<template>
    <div class="message">
        <Form :model="formItem" :label-width="100">
            <FormItem :label="$t('google.client_id')">
                <Input v-model="formItem.text"></Input>
            </FormItem>
            <!--FormItem :label="$t('google.client_secret')">
                <Input v-model="formItem.client_secret"></Input>
            </FormItem>
            <FormItem :label="$t('google.redirect_id')">
                <Input v-model="formItem.redirect_uri"></Input>
            </FormItem-->
            <FormItem>
                <Button type="primary" @click="doPost">{{$t('submit')}}</Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formItem: {}
        };
    },
    mounted(){
        this.loadData();
    },
    methods: {
        doPost() {
            this.$post(this.$path.common_info, this.formItem).then(res => {
                if (res.success) {
                    this.$Message.success('修改成功');
                } else {
                    this.$Message.error('修改失败');
                    console.error(res);
                }
            });
        },
        loadData() {
            this.$get(this.$path.common_info, {

            }).then(res => {
                if (res.data) {
                    this.formItem = res.data;
                } else {
                    this.$Message.error('获取数据失败');
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/agent/agent.vue